import { useSiteConfig } from '../context/SiteConfigContext';
import BrandLogo from '../components/BrandLogo';

export default function MaintenancePage() {
  const { config } = useSiteConfig();

  return (
    <main className="maintenance-page">
      <div className="maintenance-card">
        <BrandLogo linkTo={null} showText theme="light" className="maintenance-brand" />
        <h1>We&apos;ll be back soon</h1>
        <p>
          {config.maintenance?.message
            || 'The site is under maintenance. Please check back later.'}
        </p>
      </div>
    </main>
  );
}
